import React from "react";

import Breadcrumbs from "./Breadcrumbs";
import useFAST from "../../../contexts/FASTContext";

import type { JSX } from "react";

import type { Breadcrumb } from "./Breadcrumbs";

interface IPageHeader {
  breadcrumbs: Breadcrumb[];
  logoUrl?: string;
  isScrolling?: boolean;
}

function PageHeader({
  breadcrumbs,
  logoUrl,
  isScrolling,
}: IPageHeader): JSX.Element {
  const { state } = useFAST();
  const breadcrumbsHeight = 50;

  const { layout } = state;

  const title = layout?.header?.title;
  const button = layout?.header?.button;

  return (
    <div className="border-border text-foreground flex flex-col border-b p-[0.78125rem]">
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
        height={isScrolling ? 0 : breadcrumbsHeight}
      />
      <div className="flex w-full justify-between gap-[0.9375rem]">
        <div className="flex items-center gap-[0.9375rem] overflow-hidden">
          {logoUrl ? (
            <img alt="channel logo" className="size-[3.125rem]" src={logoUrl} />
          ) : null}
          <span className="max-w-full truncate text-[1.875rem] leading-normal font-semibold">
            {title}
          </span>
        </div>
        {button}
      </div>
    </div>
  );
}

export default PageHeader;
